const TrsutedLocalApi = () => {
    $(document).on('click','.submitTrustedLocal', function () {
        $(".spinner-border").show();
        $("#overlay").show();
        $.ajax({
            url:$(this).data('url'),
            type:'POST',
            success:function(response){
                Swal.fire('',response.message,response.status);
            },
            complete: function(){
                $(".spinner-border").hide();
                $("#overlay").hide();
            }
        })
    });
}
export default TrsutedLocalApi;
